import React 			from 'react';
import PropTypes 	from 'prop-types';

//this.props.classes	: string of classes
//this.props.crumbs 	: array of items [{content, link}]
//this.props.clean 		: boolean

export default class PageBreadcrumbs extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = '', crumbs, containerClasses = ''} = this.props;
		const items = crumbs.map((crumb, index) => <li key={index} className="page-bread-crumbs__item">{crumb.link ? <a href={crumb.link}>{crumb.content}</a> : crumb.content}</li>);

		return (
			<section className={"page-bread-crumbs__container " + containerClasses}>
				<ul className={"page-bread-crumbs " + classes}>
					{items}
				</ul>
			</section>
		);
	}
}

PageBreadcrumbs.propTypes = {
		classes: PropTypes.string
	,	crumbs: PropTypes.arrayOf(PropTypes.shape({
				content: PropTypes.string
			, link: PropTypes.string
	})).isRequired
}